import React from 'react';
import {CurrencySwitcher} from '@homeaway/react-currency-switcher';
import {CurrencyMenuItemsWrapper} from '../components/tray/currency-menu-items-wrapper/CurrencyMenuItemsWrapper';
import URLSearchParams from 'url-search-params';

export default class CurrencySelectorConnector extends React.Component {
    getRedirectUrl = (currency) => {
        let origin = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
        let params = new URLSearchParams(window.location.search);
        if (this.props.currencyCode !== currency) {
            params.set('gx-currency', currency);
        }
        return `${origin}${params.toString() !== '' ? `?${params.toString()}` : ''}`;
    };

    handleChangeCurrencySelector = (currency) => {
        if (window && window.location) {
            const redirectUrl = this.getRedirectUrl(currency);
            let locale = null;
            let siteUrl = null;

            if (this.props.onCurrencySelectorChange) {
                this.props.onCurrencySelectorChange({
                    redirectUrl,
                    locale,
                    currency,
                    siteUrl
                });
            } else {
                window.location.assign(redirectUrl);
            }
        }
    };

    render() {
        if (!this.props.currencyList) {
            return <CurrencySwitcher {...this.props} onCurrencySelectorChange={this.handleChangeCurrencySelector} />;
        }

        return (
            <CurrencyMenuItemsWrapper
                translations={this.props.translations}
                currencyList={this.props.currencyList}
                selectedCurrency={this.props.currencyCode}
                isTopCurrenciesView={this.props.isTopCurrenciesView}
                handleShowAllCurrenciesClick={this.props.handleShowAllCurrenciesClick}
                onCurrencySelectorChange={this.handleChangeCurrencySelector}
            />
        );
    }
}
